import React from 'react';
import './ImagePage.scss';

const ImagePage = () => {
  const table1 = [
    { fileName: 'NVDDictionaryImage_Viewpoint.txt', description: 'Provides the viewpoint name for each image view point.' },
    { fileName: 'NVDImageSet_ViewPoint.txt', description: 'Determines if the image id forms part of a set.' },
    { fileName: 'NVDModelYear.txt', description: 'The table provides the Model Year reference and effective dates for any given cap id.' },
    {
      fileName: 'CIMAGE.mdd', description: 'This file contains numerical look up references to Manufacturer, Model, and Derivative details ' +
        'as found in Vehicles tables below. '
    }
  ];

  const table2 = [
    { title: 'Cman.###', description: 'This table provides all of the manufacturer names each with a unique code.' },
    {
      title: 'Cmodran.###', description: 'This table provides all of the range names, each with a unique code and a reference ' +
        'to the manufacturer code to which they belong.'
    },
    {
      title: 'Cmod.###', description: 'Table provides all the model range names, each with a unique code and a reference to the ' +
        'manufacturer and range code to which they belong.'
    },
    {
      title: 'Ctrim.###', description: 'This gives all the trim descriptions, each with a unique code and a reference to the ' +
        'manufacturer, range & model range code to which they belong.'
    },
    { title: 'Cder.###', description: 'Table contains vehicle codes and description with lookups back to the tables listed above.' }
  ];

  return (
    <div className='image-page-container'>
      <h1>Images</h1>
      <div className='button-images link-images-container-flex'>
        <a className='white-text' href="https://download.cap.co.uk/NVDEnhancedImages/CapImages300.zip">
          Download Image Transfer Application
        </a>
      </div>
      <div className='pdf-content'>
        <h2>Requirements</h2>
        <p>
          The download application is designed to run on Microsoft Windows Operating systems.
        </p>
        <ol>
          <li>The 'CAPImages.exe' application. Available for download using the button above.</li>
          <li>A subscription to one or more of the following products:
            <ul>
              <li>Car Images - Supports 5 exterior image view points and an interior image.</li>
              <li>Car Images (Legacy Single Image) - Single front ¾ exterior image of vehicles.</li>
              <li>LCV Images (Single Image) - Single front ¾ exterior image of vehicles.</li>
            </ul>
          </li>
          <li>Microsoft .Net Framework 4.</li>
          <li>Configuration details: your subscriber ID and password.</li>
          <li>There should be 4GB of free space on the machine, however the application enables libraries of resized images to be created. This will increase the amount of space
            required.</li>
        </ol>
        <h2>What does this application do?</h2>
        <p>
          The Images download application allows the download of the full cap hpi  image database (subject to appropriate subscription)
          and then subsequent image updates. The application can be used for the following:
        </p>
        <ol>
          <li>Download and Update Vehicle Images supplied by cap hpi at an image resolution of 1024 x 768.</li>
          <li>Create libraries of user defined re-sized images ready for use on web sites or in applications.</li>
        </ol>
        <p>
          The application can be either run interactively or setup to run via Windows Scheduler for automated updates.
        </p>
        <h2>Basic Application Setup</h2>
        <p>
          Below is a set of instructions which will enable the application to create the base library of available images
          at 1024 x 768 resolution.
        </p>
        <ol>
          <li>Create a folder on the computer that will run the application. E.g: C:\CAPImages</li>
          <li>Make sure that permissions give full access to the folder (Read / Write / Create / Modify / Delete)</li>
          <li>Extract the CapImage.exe file from the compressed archive and place in application folder.</li>
          <li>Run the application for the first time.</li>
          <li>Click on 'Configuration'.</li>
          <li>Enter the 'Subscriber ID' and 'Password' supplied to you by cap hpi.</li>
          <li>Enter your e-mail address, used to verify the configuration setup.</li>
          <li>If you are using a Proxy, tick 'Use Proxy' and enter the appropriate details.</li>
          <li>Click on the 'Test Connection' button.</li>
          <li>A screen confirmation and email will verify the setup.</li>
          <li>Press the 'Close' button.</li>
        </ol>
        <h2>Create Re-sized image</h2>
        <p>
          The application can create re-sized images sets. There is no limit to the number of sizes that can be created.
          (This does not require an internet connection.)
        </p>
        <p>
          By default the download application creates a 'master' library of all images. These are stored at a resolution of
          1024 x 768. To create a set of images at a required size do the following:
        </p>
        <ol>
          <li>Set the 'Output Folder' to the desired location of the image set that you wish to create. This can be:
            <ul>
              <li>The same location as the download application.</li>
              <li>A folder on the local computer.</li>
              <li>A Mapped Network Drive.</li>
            </ul>
          </li>
          <li>Click on the 'Add' button at the bottom of the screen.</li>
          <li>A new dialog will appear.</li>
          <li>Select the vehicle 'Type' for the image set. Note: The appropriate subscription is needed for the different image types.</li>
          <li>Enter a 'Set Name'. This will become the folder that the images are stored in, within the 'Output Folder'.</li>
          <li>Enter the required 'Width' or 'Height'. Note: The aspect ratio will be maintained when entering values.</li>
          <li>Select the appropriate 'Image Format'. There is a choice of JPG, PNG or BMP.</li>
          <li>Press the 'Save' button.</li>
        </ol>
        <p>
          At this point a new entry will appear in the main dialog box on the screen.
        </p>
        <p>
          The above process can be repeated as many times as appropriate to build up several sets of different sized re-sized image sets.
        </p>
        <h2>Deleting unwanted Re-sized images sets.</h2>
        <p>
          If you no longer require a particular re-sized image set simply double click on the appropriate row that requires deleting.
          A prompt confirming the deletion will appear.
        </p>
        <h2>Downloading the Images for the first time.</h2>
        <p>
          The initial download of images may take some time to process. The first download creates the complete library of images at
          1024 x 768 resolution.
        </p>
        <p>
          Once the library has been downloaded, the resized images are created. This part of the process uses the locally stored Image
          Library to create the re-sized images. The internet is not used when creating the re-sized images.
        </p>
        <p>
          To perform the download, press the 'Update Image Sets' button. The status bar at the bottom of the screen will update with
          relevant information. Once the process is complete, a success dialog confirms that the process has finished.
        </p>
        <h2>Updating the Images</h2>
        <p>
          The Image products should be updated on a regular basis. The application will only download images that are not held within
          the local library. Usually, this process happens quite quickly. New images are downloaded into the local library and then
          resized images are created as needed.
        </p>
        <h2>Automating the update process</h2>
        <p>
          It is possible to run the download program and perform updates automatically. The program should be run with the /batch
          parameter added. The application launches and performs an update, downloading required images and resizing as necessary.
          Once everything has been updated the application closes.
        </p>
        <p>
          By using the /batch parameter, it is possible to either include the update within a batch process or alternatively directly
          schedule the application to run on a specific time schedule.
        </p>
        <h2>Technical Details</h2>
        <h4>Folder Structure</h4>
        <p>
          The suggested default folder used is C:\CAPImages, but this is not mandatory.
        </p>
        <p>
          The application will create the image library in sub folder called 'Original Images' under the main folder.
        </p>
        <p>
          This library holds all the full size 1024 x 768 images. The application manages this folder and it should <b>not</b> be modified.
        </p>
        <p>
          Resized Images again can be stored in any folder. A folder using the 'Set Name' is created under the storage
          path \ vehicle type folder. If there are several sets of images, there will be several folders. E.g: C:\CAPImages\CAR\Small
          or C:\CAPImages\LCV\Display.
        </p>
        <p>
          The application will create CAR and LCV folders as appropriate to your subscription. Each folder contains an Image ASCII and
          a Vehicle ASCII folder, which contain data files which will enable the images to be linked to vehicle descriptions and
          codes/ID's.
        </p>
        <h4>ASCII Files</h4>
        <p>
          Upon initial download, a set of ASCII files will be created, which can be used to link the Images to specific cap Ids.
          These files can also be updated when new images are updated. The following files are supplied:
        </p>
        <table>
          <thead>
            <tr>
              <th className="product-header">
                <span>
                  File Name (CAR or LCV)
                </span>
              </th>
              <th className="product-header">
                <span>
                  Description
                </span>
              </th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th className="product-header" colSpan={2}>
                <span>
                  Image ASCII sub-set (prefix database_yyyy-mm-dd)
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {table1.map((table1, index) => (
              <tr key={index}>
                <td className="product-column">{table1.fileName}</td>
                <td className="product-column">{table1.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th className="product-header" colSpan={2}>
                <span>
                  Vehicle ASCII sub-set (suffix denotes month & date of publication - e.g. N21)
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {table2.map((table2, index) => (
              <tr key={index}>
                <td className="product-column">{table2.title}</td>
                <td className="product-column">{table2.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <h4>CSV Files</h4>
        <p>
          The CapImage application also generates CSV files containing the same data as the corresponding ASCII files. Each CSV file shares the same filename as its ASCII counterpart, differing only by the .csv extension.
        </p>
      </div>
    </div>
  );
};

export default ImagePage;